import { SAFE_API_DEFAULT_LIMIT } from '@/constants/main'
import { getEnv } from '@/config/env'

export interface SafeApiResponse {
  items: Array<{
    id: string
    chainId: number
    name: string
    address: string
    ownerA: string
    ownerB: string
    recallModule: string
  }>
  total: number
  limit: number
  offset: number
  order: string
}

export interface FetchSafesParams {
  limit?: number
  offset?: number
  order?: 'ASC' | 'DESC'
  chainIds: number
}

export async function fetchSafes(
  apiUrl: string,
  params: FetchSafesParams
): Promise<SafeApiResponse> {
  const queryParams = new URLSearchParams({
    limit: String(params.limit ?? SAFE_API_DEFAULT_LIMIT),
    offset: String(params.offset ?? 0),
    order: params.order ?? 'DESC',
    chainIds: String(params.chainIds),
  })

  const response = await fetch(`${apiUrl}/v1/admin/safes?${queryParams}`, {
    method: 'GET',
    headers: {
      accept: '*/*',
    },
  })

  if (!response.ok) {
    throw new Error(
      `Failed to fetch safes: ${response.status} ${response.statusText}`
    )
  }

  return response.json()
}

export async function updateSafeName(
  apiUrl: string,
  safeId: string,
  name: string
): Promise<void> {
  const env = getEnv()
  if (!env.adminBearerToken) {
    throw new Error('Admin bearer token is not configured')
  }

  const response = await fetch(`${apiUrl}/v1/admin/safes/${safeId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${env.adminBearerToken}`,
    },
    body: JSON.stringify({
      name,
    }),
  })

  if (!response.ok) {
    const errorText = await response.text()
    let errorMessage = errorText
    try {
      const errorJson = JSON.parse(errorText)
      if (errorJson.message) {
        errorMessage = errorJson.message
      } else if (errorJson.error) {
        errorMessage = errorJson.error
      } else {
        errorMessage = errorText || 'Failed to update safe name'
      }
    } catch {
      if (errorText) {
        errorMessage = errorText
      } else {
        errorMessage = 'Failed to update safe name'
      }
    }
    throw new Error(errorMessage)
  }
}
